import { createContext, FC, ReactNode, useContext } from 'react';

import { defaultConfig, MainConfig } from '#/service/config';

// do not export. intended to be private, and only usable via the useConfig hook
const ConfigContext = createContext<MainConfig>(defaultConfig);

interface Props {
  children?: ReactNode;
  config: MainConfig;
}

export const ConfigProvider: FC<Props> = ({ children, config }) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);

export const useConfig = () => useContext(ConfigContext);

// TODO: smaller hooks like useConfigTheme
